module.exports = __webpack_public_path__ + "static/media/iconTest.6895aee1.svg";